import { motion } from "framer-motion";
import { LineReveal } from "@/components/Reveal";

export default function PageHeader({ overline, title, lead }) {
  return (
    <section className="relative pt-36 pb-20 overflow-hidden noise" data-testid="page-header">
      <div className="absolute inset-0 grid-bg opacity-70" />
      <div className="hero-orb w-[500px] h-[500px] -top-40 -right-40 glow-primary" />
      <div className="relative max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="overline mb-5">{overline}</div>
        <h1 className="font-serif text-[clamp(2.75rem,6vw,5.5rem)] tracking-[-0.02em] leading-[0.95]">
          <LineReveal>{title}</LineReveal>
        </h1>
        {lead && (
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.35, duration: 0.7 }}
            className="mt-8 max-w-[560px] text-[15.5px] text-[color:var(--text-muted)] leading-relaxed"
          >
            {lead}
          </motion.p>
        )}
      </div>
    </section>
  );
}
